export const config: IConfig.IConfigParams = {
  apiURL: "https://online.turkmenturkbank.com.tm/online_back",
  otpUrl: "https://online.turkmenturkbank.com.tm/otp",
  cdnUrl: "https://online.turkmenturkbank.com.tm/online_back/public",
  get_footer_bottom_title: (allRightsReserved: string) =>
    `${new Date().getFullYear()}. ${allRightsReserved}`,
  creditsURL: "https://turkmenturkbank.com.tm/tk/credits21",
};
